export const dhlIconsStyles = {
  '.DhlSvgStack-root': {
    display: 'inline-flex',
    position: 'relative',
  },

  '.DhlSvgStack-root svg': {
    position: 'relative',
  },

  '.DhlSvgStack-root.DhlSvgStack-top-right svg': {
    padding: '0.1em 0.1em 0 0',
  },

  '.DhlSvgStack-root.DhlSvgStack-centered svg': {
    padding: '0.125em',
  },

  '.DhlSvgStack-root.DhlSvgStack-full svg': {
    padding: '0',
  },

  '.DhlSvgStack-root.DhlSvgStack-top-right svg:last-of-type': {
    position: 'absolute',
    padding: '0',
  },

  '.DhlSvgStack-root.DhlSvgStack-centered svg:first-of-type, .DhlSvgStack-root.DhlSvgStack-full svg:first-of-type': {
    position: 'absolute',
    padding: '0',
  },
}
